import Cable from './cable';

export default Cable;
